import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, SectionTag, SectionTitle } from "./shared";
import { IMG } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function SiteVisit() {
  const [form, setForm] = useState({ name: "", phone: "", configuration: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please share your name and phone number.");
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/leads`, { ...form, lead_type: "site-visit", property_type: form.configuration });
      toast.success("Site visit requested. We will confirm your slot shortly.");
      setForm({ name: "", phone: "", configuration: "", message: "" });
    } catch {
      toast.error("Could not submit right now. Please call or WhatsApp us.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="site-visit" className="relative py-28 lg:py-40 overflow-hidden bg-[#0A0A0A]" data-testid="site-visit-section">
      <div className="absolute inset-0">
        <img src={IMG.skyline} alt="Yamuna corridor skyline" className="w-full h-full object-cover img-cinematic opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-black/60 to-[#0A0A0A]" />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionTag>Site Visit</SectionTag>
          <SectionTitle className="text-4xl sm:text-5xl">See the Opportunity <span className="text-gold-gradient italic">Firsthand.</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="mt-6 text-sm sm:text-base text-[#A1A1AA] leading-relaxed max-w-md">
              Explore Gaur Yamuna City, the Ace and Purvanchal developments in Sector 22D, and the
              wider YEIDA growth corridor with a Radiance property advisor.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="border border-[#D4AF37]/25 bg-black/60 backdrop-blur-md rounded-[2px] p-7" data-testid="site-visit-form">
            <div className="grid gap-3">
              <input data-testid="visit-name-input" className="lux-input" placeholder="Full Name *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="visit-phone-input" className="lux-input" placeholder="Phone *" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <input data-testid="visit-interest-input" className="lux-input" placeholder="Interested In (e.g. Waterfront Plots)" value={form.configuration} onChange={(e) => setForm({ ...form, configuration: e.target.value })} />
              <input data-testid="visit-note-input" className="lux-input" placeholder="Preferred date / notes" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
            <button
              data-testid="visit-submit-btn"
              disabled={busy}
              className="mt-5 w-full py-4 text-[12px] font-semibold uppercase tracking-[0.22em] bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black hover:from-[#D4AF37] hover:to-[#F3E5AB] transition-colors rounded-[2px] disabled:opacity-50"
            >
              {busy ? "Booking..." : "Book a Site Visit"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
